export default __webpack_public_path__ + "static/media/gp.32868dc5.svg";